/**
 * Created by Mehraz on 2017-09-14.
 */
import {store} from '../store'

export default (to, from, next) => {
  if (store.getters.user) {
    next()
  } else {
    next('/signin')
  }
}
